import { EMAIL_ERROR_MESSAGES } from './constants/EmailMessages';
import { ApiError } from 'shared/http';
import { SEND_EMAIL_CONFIRMATION } from '../../shared/constants/GenericMessages';

export class EmailError {
  public specificError: string;

  constructor(error: ApiError, status?: number) {
    this.specificError = error.message;

  }

  get message(): string {

    switch (this.specificError) {
      case 'email_duplicated':
        return EMAIL_ERROR_MESSAGES.duplicatedEmail;
      case 'request_already_sent':
        return SEND_EMAIL_CONFIRMATION.warning;
      default:
        return EMAIL_ERROR_MESSAGES.genericError;
    }
  }
}
